// Badge — DRY: one status pill, reused for publish/payment/attendance states.
import type { ReactNode } from "react";

type BadgeTone = "green" | "gray" | "gold" | "red" | "blue";

const TONE_CLASSES: Record<BadgeTone, string> = {
  green: "bg-green-100 text-green-700",
  gray:  "bg-gray-100 text-dm-slate",
  gold:  "bg-amber-100 text-amber-800",
  red:   "bg-red-100 text-red-700",
  blue:  "bg-blue-100 text-blue-700",
};

interface BadgeProps {
  tone: BadgeTone;
  title?: string | undefined;   // hover hint
  children: ReactNode;
}

export default function Badge({ tone, title, children }: BadgeProps) {
  return (
    <span title={title} className={`text-xs px-2 py-1 rounded-full font-medium capitalize ${TONE_CLASSES[tone]}`}>
      {children}
    </span>
  );
}
